import { Company } from "./company";
import { SystemField } from "./system-field";

export class MetadataConfig extends SystemField { 
    name?:string;
    value?:string;
    company_id?:string;

    // relationship
    company?:Company;
}
